// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ef2d8a6d","44":"e13efc65","75":"1d076071","309":"c98a05f4","380":"5867112a","580":"773ecdc8","752":"842f2a4e","905":"a658b9db","970":"68f5b4ae"}[chunkId] + ".chunk.js";
};